import { Route, createRoutesFromElements } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import NotFoundPage from "./features/NotFoundPage";
import HomePage from "./features/home/HomePage";
import CategoriesPage from "./features/catalog/CategoriesPage";
import CategoryPage from "./features/catalog/CategoryPage";
import MoviePage from "./features/media/MoviePage";
import SeriesPage from "./features/media/SeriesPage";
import PlayerPage from "./features/media/PlayerPage";
import LivePage from "./features/media/LivePage";
import ActorPage from "./features/actor/ActorPage";
import SearchPage from "./features/search/SearchPage";
import AccountPage from "./features/account/AccountPage";
import LoginPage from "./features/auth/LoginPage";
import LoginVerifyPage from "./features/auth/LoginVerifyPage";
import SignUpPage from "./features/auth/SignUpPage";
import SignUpVerifyPage from "./features/auth/SignUpVerifyPage";
import RequireAuth from "./features/auth/RequireAuth";

// Paths keep their original casing: they are live URLs people have bookmarked.
const routes = createRoutesFromElements(
  <Route path="/" element={<AppLayout />}>
    <Route index element={<HomePage />} />

    <Route path="Login" element={<LoginPage />} />
    <Route path="Login/loginVerify" element={<LoginVerifyPage />} />
    <Route path="Signup" element={<SignUpPage />} />
    <Route path="Signup/signUpVerify" element={<SignUpVerifyPage />} />

    <Route path="Query" element={<SearchPage />} />
    <Route path="Categories" element={<CategoriesPage />} />
    <Route path="category/:id" element={<CategoryPage />} />
    <Route path="movies/:id" element={<MoviePage />} />
    <Route path="series/:id" element={<SeriesPage />} />
    <Route path="Actor/:id" element={<ActorPage />} />
    <Route path="LivePlayer/:id" element={<LivePage />} />

    <Route element={<RequireAuth />}>
      <Route path="PlayMovie/:id" element={<PlayerPage type="movie" />} />
      <Route path="PlayEpisode/:id" element={<PlayerPage type="episode" />} />
      <Route path="Account" element={<AccountPage />} />
    </Route>

    <Route path="*" element={<NotFoundPage />} />
  </Route>
);

export default routes;
